module.exports = __webpack_public_path__ + "img/shop_pdd.6176462d.png";